import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle"]

  toggleFeature(event) {
    const checkbox = event.target
    const url = checkbox.dataset.url
    const featureName = checkbox.dataset.featureName
    const modelName = checkbox.dataset.modelName || "Setting"

    Rails.ajax({
      url: url,
      type: "PUT",
      data: `feature_name=${featureName}`,
      dataType: "json",
      success: () => {
        $.notify(`${modelName} has been updated.`, "success")
      },
      error: () => {
        $.notify(`Failed to update ${modelName.toLowerCase()}. Please try again.`, "danger")
        checkbox.checked = !checkbox.checked
      }
    })
  }
}
